/* @flow */

import React from 'react';
import glamorous from 'glamorous';
import InviteFriendForm from './InviteFriendForm';

const Title = glamorous.div(({ theme }) => ({
  color: theme.color.basis2,
  fontSize: theme.fontSize.default,
  margin: '0 0 0.25em',
  textTransform: 'uppercase',
}));

const SubTitle = glamorous.div(({ theme }) => ({
  color: theme.color.basis2,
  fontSize: theme.fontSize.default,
  margin: '0 0 0.25em',
  paddingBottom: 10,
}));

const Bold = glamorous.span(({ theme }) => ({
  fontWeight: theme.fontWeight.bold,
}));

function EmailInviteForm() {
  return (
    <div>
      <Title>
        More <Bold>Players</Bold> equals bigger <Bold>prize pools</Bold>
      </Title>
      <SubTitle>Spread the word and invite your mates now!</SubTitle>
      <InviteFriendForm />
    </div>
  );
}

export default EmailInviteForm;
